import { BaseApiRouteService } from "mrb/core";

class AppHomeSectionApiRouteService extends BaseApiRouteService {
    constructor() {
        super("app-home-sections");
    }

    getAll(options) {
        return super.find(`${this.base}{?systemType,embed}`, options);
    }

    getFeaturedGrid(options) {
        return super.find(`${this.base}/featured-grid{?systemType,embed}`, options);
    }

    getFeaturedPages(options) {
        return super.find(`${this.base}/featured-pages{?systemType,embed}`, options);
    }

    createFeaturedPage(systemType) {
        return super.create(`${this.base}/featured-pages{?systemType}`, { systemType: systemType });
    }

    deleteFeaturedPage(pageId) {
        return super.delete(`${this.base}/featured-pages/{pageId}`, { pageId: pageId });
    }

    updateFeaturedPageGrid(pageId, resource) {
        return super.update(`${this.base}/featured-pages/{pageId}/grid`, { pageId: pageId }, resource);
    }

    getContent(options) {
        return super.find(`${this.base}/content{?systemType,searchQuery,page,rpp}`, options);
    }

    get(id, options) {
        return super.get(`${this.base}/{id}{?embed,fields}`, id, options);
    }

    create(resource) {
        return super.create(this.base, resource);
    }

    update(systemType, resource) {
        return super.update(`${this.base}{?systemType}`, { systemType: systemType }, resource);
    }

    updateFeaturedGrid(systemType, resource) {
        return super.update(`${this.base}/featured-grid{?systemType}`, { systemType: systemType }, resource);
    }

    delete(resource) {
        return super.delete(`${this.base}/{id}`, resource);
    }
}

export default AppHomeSectionApiRouteService;
